import { createSlice } from "@reduxjs/toolkit";

const safeGetItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error retrieving ${key} from localStorage:`, error);
    return null;
  }
};

const initialState = {
  user: safeGetItem("user"),
  token: safeGetItem("token"),
  isNewUser: false,
  showLogoutModal: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.showLogoutModal = false;
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", JSON.stringify(token));
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.showLogoutModal = false;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
    sessionExpired(state) {
      state.user = null;
      state.token = null;
      state.showLogoutModal = true;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
    setShowLogoutModal(state, action) {
      state.showLogoutModal = action.payload;
    },
    setIsNewUser(state, action) {
      state.isNewUser = action.payload;
    },
  },
});

export const { setUser, logout, sessionExpired, setIsNewUser, setShowLogoutModal } =
  userSlice.actions;
export default userSlice.reducer;
